import { Outlet } from "react-router";
import ChatHistory from "components/ChatHistory";
import FileExplorer from "components/FileExplorer";
import styles from "styles/chat.module.scss";

export default function ChatLayout() {
  return (
    <div className={styles.container}>
      <div className={styles.decorGradients} />
      <ChatHistory />
      {/* Renders NewChat or Chat depending on the matched route */}
      <Outlet />
      <FileExplorer />
    </div>
  );
}
